export interface IConfiguracoesEscala {
    USA_SLA_CALENDARIO: boolean;
    FECHAMENTO_CALENDARIO: string;
    CALENDARIO_FECHA_PROXIMO_MES: boolean;
}

export function getConfiguracoesEscalaPadrao(): IConfiguracoesEscala {
    return {
        USA_SLA_CALENDARIO: false,
        FECHAMENTO_CALENDARIO: '',
        CALENDARIO_FECHA_PROXIMO_MES: false,
    };
}
